import { createApp } from 'vue';
import App from './App.vue';
import pinia from './store';
import router from './router';
import '@/assets/css/style.css';
import '@/assets/css/mimio-content.css';
import $ from 'jquery';
import '@fortawesome/fontawesome-free/css/all.css'
import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'
import { plugin, defaultConfig } from '@formkit/vue'
import '@formkit/themes/genesis'
import { safeHtml } from '@/common/safe-html'

window.$ = $;
window.env = process.env;

// Google Analytics 설정 (운영 도메인에서만 — 비운영(dev/stg/local) 트래픽이 운영 GA 속성 오염 방지)
const isProdHost = ['mimio.life', 'www.mimio.life'].includes(window.location.hostname);
if (window.gtag && isProdHost) {
  window.gtag('config', 'G-9H3LQC0M36', {
    send_page_view: false, // Router에서 수동 관리
    custom_map: {
      custom_parameter_1: 'user_type',
      custom_parameter_2: 'content_category'
    }
  });
}

Kakao.init('b67c338cacd96615faeb889703dd5234');
const app = createApp(App);
app.use(router);
app.use(pinia);
app.use(FloatingVue);
app.use(plugin, defaultConfig);
app.directive('safe-html', safeHtml);
app.mount('#app');
// Kakao 객체를 전역으로 사용할 수 있도록 설정
app.config.globalProperties.$Kakao = Kakao;

if (process.env.NODE_ENV === 'production') {
    app.config.devtools = false; // 개발자 도구 비활성화
    app.config.warnHandler = () => {}; // 경고 메시지 무시
}